import { useState } from "react";
import { FormSelect, Spinner } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getCatalog, getEngines } from "../../../redux/selectors";
import { useFormik } from "formik";
import styles from "./style.module.scss";
import api from "../../../api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { addNewCatalog } from "../../../redux/reducers";

const AddCatalog = () => {
  const params: any = useParams();
  const dispatch = useAppDispatch();
  let success = useAppSelector((state) => state.productSlice.adding);
  let loader = useAppSelector((state) => state.productSlice.loading);
  const [selectedFile, setSelectedFile] = useState<any>(null);

  function handleFileUpload(event: any) {
    setSelectedFile(event.target.files[0]);
  }

  const formik = useFormik({
    initialValues: {
      amount: "",
      price: "",
      catalogName: "",
      description: "",
    },
    onSubmit: ({ amount, price, catalogName, description }) => {
      const newDetail = new FormData();
      newDetail.append("file", selectedFile);
      newDetail.append("catalogName", catalogName);
      newDetail.append("catalogType", params.catalogType);
      newDetail.append("description", description);
      newDetail.append("amount", amount);
      newDetail.append("price", price);
      dispatch(addNewCatalog(newDetail));
      let successSubmit = success;

      successSubmit
        ? toast(
            catalogName +
              " был успешно добавлен к товарам типа " +
              params.catalogType,
            { type: "success" }
          )
        : toast("Произошла ошибка, повторите попытку", { type: "error" });
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className={styles.root}>
      {loader ? (
        <Spinner />
      ) : (
        <div className={styles.inputs}>
          <input
            type="text"
            id="catalogName"
            name="catalogName"
            onChange={formik.handleChange}
            placeholder="Имя товара"
            required
          />
          <input
            required
            id="amount"
            onChange={formik.handleChange}
            type="text"
            placeholder="Количество"
          />
          <input
            required
            id="price"
            onChange={formik.handleChange}
            type="text"
            placeholder="Цена"
          />
          <input
            onChange={formik.handleChange}
            required
            placeholder="Описание товара"
            id="description"
            name="description"
          />
          <input
            required
            id="vinNumber"
            onChange={formik.handleChange}
            type="text"
            placeholder="vin-номер"
          />
          <input
            type="file"
            onChange={handleFileUpload}
            placeholder="Выберите фотографию"
            required
          />
          <button type="submit">Создать Деталь</button>
        </div>
      )}
    </form>
  );
};

export default AddCatalog;
